import { Routes, Route, Navigate } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import BlankLayout from '../layouts/BlankLayout';
import PropertiesRoutes from './PropertiesRoutes';
import HomePage from '../pages/properties/HomePage';
import PostsRoutes from './PostsRoutes';
import PostsHomePage from '../pages/posts/HomePage';
import InvitePage from '../pages/InvitePage';
import ChatbotPage from '../pages/chatbot/ChatBotPage';
import ChatLayout from '../pages/channel/chat-layout';
//import ModulesPage from '../components/modules-page/ModulesPage';
//import DashboardCitas from '../components/Appointments/AppointmentesHomePage';
import AppointmentRoutes from './AppointmentRoutes';
import ConfirmAppointmentPage from '../pages/appointments/confirmAppointmentPage';
import { BrokersPage } from '../pages/brokers/BrokersPage';
import { PropertiesInventoryRoutes } from './PropertiesInventoryRoutes';
import CompanyLayout from '../layouts/CompanyLayout';
import { CrmRoutes } from './CrmRoutes';

const AppRoutes = () => {

  return (
    <>
    <Routes>

       {/* 🌟 NUEVO: Rutas personalizadas por compañía */}
      <Route path="/company/:pageUrl/*" element={<CompanyLayout />}>
        {/* Aquí se inyectan tus rutas existentes */}
        <Route path="properties/*" element={<PropertiesRoutes />} />
        <Route path="posts/*" element={<PostsRoutes />} />
        <Route path="appointments/*" element={<AppointmentRoutes />} />
        <Route path="brokers" element={<BrokersPage />} />
        <Route path="invite" element={<InvitePage />} />
        <Route path="properties-inventory/*" element={<PropertiesInventoryRoutes />} />
        <Route path="crm/*" element={<CrmRoutes />} />
        {/* Puedes añadir más módulos si quieres */}
        
      </Route>

      {/* Ruta raíz que redirige a la página de inicio de propiedades */}
      <Route path="/" element={<Navigate to="properties/home" />} />
      <Route path="appointments/confirm" element={<ConfirmAppointmentPage />} />
      <Route path="appointments/cancel" element={<ConfirmAppointmentPage />} />

      {/* Módulo de propiedades */}
      <Route path="/properties" element={<MainLayout />}>

        <Route index element={<Navigate to="home" />} />

        <Route path="home" element={<HomePage />} />

      </Route>

      <Route path="chatbot" element={<ChatbotPage />} />

      <Route path="/properties/*" element={<BlankLayout />}>
        <Route path="*" element={<PropertiesRoutes />} />
      </Route>


      {/* Módulo de oportunidades */}
      <Route path="/posts" element={<MainLayout />}>
        <Route index element={<Navigate to="home" />} />

        <Route path="home" element={<PostsHomePage />} />
      </Route>

      <Route path="/posts/*" element={<BlankLayout />}>
        <Route path="*" element={<PostsRoutes />} />
      </Route>

      <Route path="/invite" element={<BlankLayout />}>
        <Route index element={<InvitePage />} />
      </Route>

            {/* Módulo de propiedades */}
      <Route path="/channels" element={<BlankLayout />}>


        <Route index element={<Navigate to="home" />} />

        <Route path="home" element={<ChatLayout />} />

      </Route>

      <Route path="/appointments/*" element={<AppointmentRoutes />} />

      <Route path='/brokers' element={<BrokersPage />} />

     <Route path='/properties-inventory/*' element={<PropertiesInventoryRoutes />} />

    </Routes>
     {/* Modulo CRM */}
      <Routes>
         <Route path="/crm/*" element={<CrmRoutes />} />
      </Routes>
    </>
  );
};

export default AppRoutes;
